import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectTimelinePanel = ({ project }) => {
  const timelineEvents = [
    {
      id: 1,
      title: 'Inicio del Proyecto',
      description: 'Registro oficial del proyecto en el estándar Verra',
      date: '2024-03-15',
      status: 'completado',
      icon: 'Flag',
      color: 'var(--color-success)'
    },
    {
      id: 2,
      title: 'Validación Inicial',
      description: 'Auditoría de tercera parte completada exitosamente',
      date: '2024-06-20',
      status: 'completado',
      icon: 'CheckCircle',
      color: 'var(--color-success)'
    },
    {
      id: 3,
      title: 'Primera Verificación',
      description: 'Verificación de emisiones reducidas del primer período',
      date: '2025-01-10',
      status: 'completado',
      icon: 'Shield',
      color: 'var(--color-success)'
    },
    {
      id: 4,
      title: 'Emisión de Créditos',
      description: 'Generación de 32,450 créditos de carbono verificados',
      date: '2025-03-05',
      status: 'completado',
      icon: 'Award',
      color: 'var(--color-success)'
    },
    {
      id: 5,
      title: 'Monitoreo Continuo',
      description: 'Recolección de datos de campo y análisis geoespacial',
      date: '2025-09-15',
      status: 'en_progreso',
      icon: 'Activity',
      color: 'var(--color-warning)'
    },
    {
      id: 6,
      title: 'Segunda Verificación',
      description: 'Auditoría programada para el segundo período de monitoreo',
      date: '2026-02-28',
      status: 'programado',
      icon: 'Calendar',
      color: 'var(--color-primary)'
    },
    {
      id: 7,
      title: 'Renovación de Certificación',
      description: 'Renovación del registro del proyecto ante el estándar',
      date: '2027-03-15',
      status: 'programado',
      icon: 'RefreshCw',
      color: 'var(--color-muted-foreground)'
    }
  ];

  const getStatusLabel = (status) => {
    const labels = {
      completado: 'Completado',
      en_progreso: 'En Progreso',
      programado: 'Programado'
    };
    return labels?.[status] || status;
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="Clock" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-xl font-semibold font-mono">Cronograma del Proyecto</h2>
      </div>
      <div className="relative">
        <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-border" />

        <div className="space-y-6">
          {timelineEvents?.map((event, index) => (
            <div key={event?.id} className="relative flex gap-4">
              <div
                className="flex items-center justify-center w-12 h-12 rounded-full flex-shrink-0 z-10"
                style={{ backgroundColor: `${event?.color}15` }}
              >
                <Icon name={event?.icon} size={20} color={event?.color} />
              </div>

              <div className="flex-1 pb-6">
                <div className="flex items-start justify-between gap-4 mb-2">
                  <div>
                    <h3 className="text-sm font-medium text-foreground mb-1">{event?.title}</h3>
                    <p className="text-xs text-muted-foreground caption">{event?.description}</p>
                  </div>
                  <span
                    className="px-2 py-1 text-xs rounded caption font-medium flex-shrink-0"
                    style={{
                      backgroundColor: `${event?.color}15`,
                      color: event?.color
                    }}
                  >
                    {getStatusLabel(event?.status)}
                  </span>
                </div>

                <div className="flex items-center gap-2 mt-3">
                  <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
                  <span className="text-xs text-muted-foreground caption">
                    {new Date(event.date)?.toLocaleDateString('es-ES', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectTimelinePanel;